import styled from "styled-components";
import {LobbyHeaderDefaultBox} from "./lobby-header.default.box";
import {STICKY} from "../../../themes/css-global-classes";

export const LobbyHeaderSiBox = styled(LobbyHeaderDefaultBox)`
  &.${STICKY} {
    @media ${({theme}) => theme.mediaQuery.xlAndAbove} {
      background-image:none;
    }
  }
`